import { Component, type ErrorInfo, type ReactNode } from "react";

type AppErrorBoundaryProps = {
  children: ReactNode;
  onSignIn: () => void;
  onReload: () => void;
};

type AppErrorBoundaryState = {
  error: Error | null;
};

function isAuthError(error: Error) {
  return /UNAUTHENTICATED|FORBIDDEN|AUTH/i.test(error.message || "");
}

export default class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("App runtime error:", error, errorInfo);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    const authError = isAuthError(this.state.error);
    const subtitle = authError
      ? "Your secure session expired. Please sign in again."
      : "Something went wrong while loading secure data. Reload to continue.";

    return (
      <div className="auth-screen">
        <div className="auth-card">
          <div className="auth-title">Fleet Dispatch</div>
          <div className="auth-subtitle">{subtitle}</div>
          <button
            type="button"
            className="auth-primary-btn"
            onClick={authError ? this.props.onSignIn : this.props.onReload}
          >
            {authError ? "Sign in again" : "Reload app"}
          </button>
        </div>
      </div>
    );
  }
}
